import * as React from 'react';
import {
  Grid, Divider, Card, CardContent,
  Typography,
  CardHeader,
  Paper,
  Tooltip,
  Zoom,
} from '@material-ui/core';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import type { GridColumns } from '@material-ui/data-grid';
import { DataGrid } from '@material-ui/data-grid';

const tableColumns: GridColumns = [
  {
    field: 'station',
    headerName: 'Station',
    flex: 0.75,
  },
  {
    field: 'reason',
    headerName: 'Reject Reason',
    flex: 1,
  },
  {
    field: 'comment',
    headerName: 'Comment',
    flex: 1,
    renderCell: ({ value }) => (
      <Tooltip TransitionComponent={Zoom} title={value || 'No Comment'}>
        <span>
          {value}
        </span>
      </Tooltip>
    ),
  },
  {
    field: 'scannedBy',
    headerName: 'Scanned By',
    flex: 1,
  },
  {
    field: 'created',
    headerName: 'Created',
    flex: 1,
  },
];
interface IRejectLog {
  station: string;
  reason: string;
  comment: string;
  created: string;
  scannedBy: string;
}

interface RejectLogProps {
  barcode: string;
}

const RepairRejectLog: React.FC<RejectLogProps> = ({ barcode }) => {
  const { enqueueSnackbar } = useSnackbar();

  const rejectLogFetcher = (url: string, barcodeParam: string) => axios.get<IRejectLog[]>(url, {
    params: {
      barcode: barcodeParam,
    },
  }).then((res) => res.data)
    .catch((e: AxiosError) => {
      enqueueSnackbar(e?.response?.data, { persist: false, variant: 'error' });
    });

  const { data: rejectLogs } = useSWR(['/RepairLookup/RejectLogs', barcode], (url, barcodeParam) => rejectLogFetcher(url, barcodeParam));

  const tableRows = rejectLogs && rejectLogs?.map((log, index) => ({
    id: index || '',
    station: log?.station,
    reason: log?.reason,
    comment: log?.comment,
    created: new Date(`${log?.created}z`).toLocaleString(),
    scannedBy: log?.scannedBy,
  }));

  return (
    <>
      <Grid item xs={12}>
        <Paper>
          <Card>
            <CardHeader
              title={(
                <Typography variant="h6" display="inline">{'Repair Reject Log History'}</Typography>
                            )}
              disableTypography
            />
            <CardContent>
              <DataGrid
                rows={tableRows || []}
                columns={tableColumns}
                disableColumnMenu
                autoHeight
                pageSize={50}
              />
            </CardContent>
          </Card>
        </Paper>
      </Grid>
      <Grid>
        <Divider orientation="vertical" />
      </Grid>
    </>
  );
};

export default RepairRejectLog;
